// REACT
import React, { Component } from 'react';

// REDUX
import { connect } from 'react-redux';
import * as actions from 'actions';

// UTILS
import { getUserTimezone } from '../../../utils/timezoneUtils';

// VENDOR
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import Toggle from 'material-ui/Toggle';

export const NavControls = (props) => {
    const { styles, canGoBack, onNextClick, onPrevClick } = props;
    
    return (
        <div style={ styles.calendarNav}>
            <button 
                disabled={
                    (canGoBack) ? false : true 
                } 
                style={{
                    ...styles.navButtons, 
                    cursor: (canGoBack) ? 'pointer' : 'not-allowed',
                    opacity: (canGoBack) ? 1 : 0.2
                }} 
                onClick={onPrevClick}
            >
                <FontAwesomeIcon style={{ color: 'red' }} icon={['far', 'angle-left']} />
                <span>&nbsp;PREV</span>
            </button>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', fontSize: 16 }}>
                <div style={{ textAlign: 'center' }}>YOUR TIMEZONE: {getUserTimezone()}</div> 
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <span>12hr&nbsp;</span>
                    <Toggle
                        style={styles.toggle}
                        onToggle={(event, isChecked)=>{
                            if (isChecked) {
                                props.setTimeFormat(24);
                            } else {
                                props.setTimeFormat(12);
                            }
                        }}
                        toggled={props.timeFormat === 24 ? true : false}
                    />
                    <span>&nbsp;24hr</span>
                </div>
            </div>
            <button 
                style={styles.navButtons} 
                onClick={onNextClick}
            >
                <span>NEXT&nbsp;</span>
                <FontAwesomeIcon style={{ color: 'red' }} icon={['far', 'angle-right']} />
            </button>
        </div>
    );
}


const mapStateToProps = ({time}) => {    
    return {
        timeFormat: time.format
    };
};

export default connect(mapStateToProps, actions)(NavControls);


// WEBPACK FOOTER //
// ./src/js/components/Calendar/NavControls/NavControls.jsx